module.exports = __webpack_public_path__ + "img/DE00846.94fefcfa.png";